import axios from 'axios';
import store from 'stores/indexstore';

// Function to get the current location
function getCurrentLocation() {
  return window.location.pathname; // or window.location.pathname + window.location.search for the complete URL
}

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    const { authenticationDetails } = store.getState().auth;
    const currentLocation = getCurrentLocation();

    // Check if authenticationDetails contains the token
    if (authenticationDetails && authenticationDetails.id_token) {
      config.headers.Authorization = `Bearer ${authenticationDetails.id_token}`;
    }
    if (authenticationDetails && authenticationDetails.access_token) {
      config.headers['X-Auth'] = `${authenticationDetails.access_token}`;
    }

    if (currentLocation.includes('/rs/')) {
      config.headers['x-app-slug'] = 'rhymscan';
    }
    if (currentLocation.includes('/crs/')) {
      config.headers['x-app-slug'] = 'crs';
    }
    if (currentLocation.includes('/crq/')) {
      config.headers['x-app-slug'] = 'crq';
    }
    if (currentLocation.includes('/cap/')) {
      config.headers['x-app-slug'] = 'cap';
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axios;
